import { RecordingType } from 'src/app/recordings/enum';

export const records = {
  songs: [
    {
      note: 'testNote',
      artists: ['Snowflake'],
      title: 'Come Inside',
      trackLink: 'http://ccmixter.org/content/snowflake/snowflake_-_Come_Inside_1.mp3',
      albumArtLink: 'http://ccmixter.org/content/snowflake/Madam_Snowflake_ccMixter_icon_9393x94.jpeg',
      albumTitle: 'album - Come Inside',
      id: 1,
      releaseYear: '2015',
      copyrightYear: null,
      masterControlPercents: 20,
      publishingControlPercents: 10,
      type: RecordingType.Recordings,
      duration: 173000,
      writers: ['Snowflake'],
      versions: [],
      waveformLink: '../assets/waveforms/1.json',
      hasTrackLink: true,
      playbackCount: 0,
      downloadCount: 0,
      songCode: 'code code code',
    },
    {
      note: 'testNote',
      artists: ['Tarida Gaol'],
      title: 'I\'ll Never Grow Old',
      trackLink: 'http://ccmixter.org/content/destinazione_altrove/destinazione_altrove_-_Kalte_Ohren_(_Remix_).mp3',
      albumArtLink: 'http://ccmixter.org/content/destinazione_altrove/dark_room_by_ikiz93x94.jpg',
      albumTitle: 'album - Come Inside',
      id: 2,
      releaseYear: '2017',
      masterControlPercents: 50,
      publishingControlPercents: 30,
      type: RecordingType.Recordings,
      duration: 231000,
      copyrightYear: null,
      writers: ['Tarida Gaol'],
      versions: [],
      waveformLink: '../assets/waveforms/2.json',
      hasTrackLink: true,
      playbackCount: 0,
      downloadCount: 0,
    },
    {
      note: 'testNote',
      artists: ['Jihfa'],
      title: 'Pay It Forward [Pitch Shift ReMix]',
      trackLink: 'http://ccmixter.org/content/Jihfa/Jihfa_-_Pay_It_Forward_Pitch_Shift_ReMix_.mp3',
      albumArtLink: 'http://ccmixter.org/content/Jihfa/jihfa93x94.jpg',
      albumTitle: 'album - Come Inside',
      id: null,
      releaseYear: '2019',
      masterControlPercents: 50,
      publishingControlPercents: 30,
      type: RecordingType.Recordings,
      duration: 245000,
      copyrightYear: null,
      writers: ['Jihfa'],
      versions: [],
      waveformLink: '../assets/waveforms/3.json',
      hasTrackLink: true,
      playbackCount: 0,
      downloadCount: 0,
    },
    {
      note: 'testNote',
      artists: ['Jihfa'],
      title: 'Pay It Forward [Pitch Shift ReMix]',
      trackLink: null,
      albumArtLink: 'http://ccmixter.org/content/Jihfa/jihfa93x94.jpg',
      albumTitle: 'album - Come Inside',
      id: 3,
      releaseYear: '2019',
      masterControlPercents: 50,
      publishingControlPercents: 30,
      type: RecordingType.Recordings,
      duration: 245000,
      copyrightYear: null,
      writers: ['Jihfa'],
      versions: [],
      waveformLink: '../assets/waveforms/3.json',
      hasTrackLink: true,
      playbackCount: 0,
      downloadCount: 0,
    },
    {
      note: 'testNote',
      artists: ['Jihfa'],
      title: 'Pay It Forward [Pitch Shift ReMix]',
      trackLink: 'N/A',
      albumArtLink: 'http://ccmixter.org/content/Jihfa/jihfa93x94.jpg',
      albumTitle: 'album - Come Inside',
      id: 4,
      releaseYear: '2019',
      masterControlPercents: 50,
      publishingControlPercents: 30,
      type: RecordingType.Recordings,
      duration: 245000,
      copyrightYear: null,
      writers: ['Jihfa'],
      versions: [],
      waveformLink: '../assets/waveforms/3.json',
      hasTrackLink: true,
      playbackCount: 0,
      downloadCount: 0,
    },
  ],
  page: {
    total: 3,
    pageSize: 10,
    offset: 0,
  },
  filters: [
    {
      label: 'Genres',
      name: 'genre',
      values: ['Rock', 'Pop', 'Trance', 'Hip-Hop'],
    },
    {
      label: 'Languages',
      name: 'lang',
      values: ['English', 'Russian', 'French', 'Japanese'],
    },
  ],
  activeFilters: {
    includes: [],
    excludes: [],
  },
};

export const genres: any = {
  FOLK: [
    {
      id: 73,
      code: 'Alternative Folk',
      primary: false,
    },
    {
      id: 74,
      code: 'Americana',
      primary: false,
    },
    {
      id: 75,
      code: 'Anti Folk',
      primary: false,
    },
    {
      id: 76,
      code: 'British Folk',
      primary: false,
    },
    {
      id: 77,
      code: 'Folk',
      primary: false,
    },
    {
      id: 78,
      code: 'Old Time',
      primary: false,
    },
    {
      id: 79,
      code: 'Progressive Folk',
      primary: false,
    },
  ],
  BLUES: [
    {
      id: 1,
      code: 'African Blues',
      primary: false,
    },
    {
      id: 2,
      code: 'Blues',
      primary: false,
    },
    {
      id: 3,
      code: 'Boogie-Woogie',
      primary: false,
    },
    {
      id: 4,
      code: 'British Blues',
      primary: false,
    },
    {
      id: 5,
      code: 'Chicago',
      primary: false,
    },
    {
      id: 6,
      code: 'Delta',
      primary: false,
    },
    {
      id: 7,
      code: 'Electric Blues',
      primary: false,
    },
    {
      id: 8,
      code: 'Harmonica',
      primary: false,
    },
    {
      id: 9,
      code: 'Louisiana',
      primary: false,
    },
    {
      id: 10,
      code: 'Memphis Blues',
      primary: false,
    },
    {
      id: 11,
      code: 'Piano Blues',
      primary: false,
    },
    {
      id: 12,
      code: 'Rural',
      primary: false,
    },
    {
      id: 13,
      code: 'Texas Blues',
      primary: false,
    },
    {
      id: 14,
      code: 'West Coast Blues',
      primary: false,
    },
  ],
  JAZZ: [
    {
      id: 80,
      code: 'Acid Jazz',
      primary: false,
    },
    {
      id: 81,
      code: 'Afro Jazz',
      primary: false,
    },
    {
      id: 82,
      code: 'Avant Fusion',
      primary: false,
    },
    {
      id: 83,
      code: 'Avant-Garde',
      primary: false,
    },
    {
      id: 84,
      code: 'Bebop',
      primary: false,
    },
    {
      id: 85,
      code: 'Big Band',
      primary: false,
    },
    {
      id: 86,
      code: 'Brass Band',
      primary: false,
    },
    {
      id: 87,
      code: 'Chamber Jazz',
      primary: false,
    },
    {
      id: 88,
      code: 'Cool',
      primary: false,
    },
    {
      id: 89,
      code: 'Cubop',
      primary: false,
    },
    {
      id: 90,
      code: 'Fusion',
      primary: false,
    },
    {
      id: 91,
      code: 'Jazz',
      primary: false,
    },
    {
      id: 92,
      code: 'Jazz Pop',
      primary: false,
    },
    {
      id: 93,
      code: 'Klezmer',
      primary: false,
    },
    {
      id: 94,
      code: 'Neo-Traditional Jazz',
      primary: false,
    },
    {
      id: 95,
      code: 'New Orleans',
      primary: false,
    },
    {
      id: 96,
      code: 'Ragtime',
      primary: false,
    },
    {
      id: 97,
      code: 'Smooth Jazz',
      primary: false,
    },
    {
      id: 98,
      code: 'Soul Jazz',
      primary: false,
    },
    {
      id: 99,
      code: 'Swing',
      primary: false,
    },
    {
      id: 100,
      code: 'Symphonic Jazz',
      primary: false,
    },
    {
      id: 101,
      code: 'Vocal Jazz',
      primary: false,
    },
    {
      id: 102,
      code: 'West Coast',
      primary: false,
    },
  ],
  CLASSICAL: [
    {
      id: 15,
      code: 'Ballet',
      primary: false,
    },
    {
      id: 16,
      code: 'Baroque',
      primary: false,
    },
    {
      id: 17,
      code: 'Chamber',
      primary: false,
    },
    {
      id: 18,
      code: 'Choral',
      primary: false,
    },
    {
      id: 19,
      code: 'Classical',
      primary: false,
    },
    {
      id: 20,
      code: 'Classical Crossover',
      primary: false,
    },
    {
      id: 21,
      code: 'Concerto',
      primary: false,
    },
    {
      id: 22,
      code: 'Contemporary',
      primary: false,
    },
    {
      id: 23,
      code: 'March',
      primary: false,
    },
    {
      id: 24,
      code: 'Opera',
      primary: false,
    },
    {
      id: 25,
      code: 'Orchestral',
      primary: false,
    },
    {
      id: 26,
      code: 'Overture',
      primary: false,
    },
    {
      id: 27,
      code: 'Prelude',
      primary: false,
    },
    {
      id: 28,
      code: 'Recit',
      primary: false,
    },
    {
      id: 29,
      code: 'Renaissance',
      primary: false,
    },
    {
      id: 30,
      code: 'Symphonic',
      primary: false,
    },
    {
      id: 31,
      code: 'Viennese',
      primary: false,
    },
    {
      id: 32,
      code: 'Vocal',
      primary: false,
    },
  ],
  LATIN: [
    {
      id: 103,
      code: 'Afro Cuban',
      primary: false,
    },
    {
      id: 104,
      code: 'Afro Latin',
      primary: false,
    },
    {
      id: 105,
      code: 'Alternative Latin Music',
      primary: false,
    },
    {
      id: 106,
      code: 'Argentinian',
      primary: false,
    },
    {
      id: 107,
      code: 'Axé',
      primary: false,
    },
    {
      id: 108,
      code: 'Bachata',
      primary: false,
    },
    {
      id: 109,
      code: 'Banda',
      primary: false,
    },
    {
      id: 110,
      code: 'Basque',
      primary: false,
    },
    {
      id: 111,
      code: 'Beguine',
      primary: false,
    },
    {
      id: 112,
      code: 'Bolero',
      primary: false,
    },
    {
      id: 113,
      code: 'Bossa Nova',
      primary: false,
    },
    {
      id: 114,
      code: 'Brazilian Funk',
      primary: false,
    },
    {
      id: 115,
      code: 'Brazilian Jazz',
      primary: false,
    },
    {
      id: 116,
      code: 'Brazilian Rock',
      primary: false,
    },
    {
      id: 117,
      code: 'Cha Cha',
      primary: false,
    },
    {
      id: 118,
      code: 'Charanga',
      primary: false,
    },
    {
      id: 119,
      code: 'Choro',
      primary: false,
    },
    {
      id: 120,
      code: 'Conjunto',
      primary: false,
    },
    {
      id: 121,
      code: 'Corridos',
      primary: false,
    },
    {
      id: 122,
      code: 'Cuban',
      primary: false,
    },
    {
      id: 123,
      code: 'Cuban Son',
      primary: false,
    },
    {
      id: 124,
      code: 'Cumbia',
      primary: false,
    },
    {
      id: 125,
      code: 'Danzon',
      primary: false,
    },
    {
      id: 126,
      code: 'Duranguense',
      primary: false,
    },
    {
      id: 127,
      code: 'Fado',
      primary: false,
    },
    {
      id: 128,
      code: 'Flamenco',
      primary: false,
    },
    {
      id: 129,
      code: 'Forró',
      primary: false,
    },
    {
      id: 130,
      code: 'Frevo',
      primary: false,
    },
    {
      id: 131,
      code: 'Infantil',
      primary: false,
    },
    {
      id: 132,
      code: 'Lambada',
      primary: false,
    },
    {
      id: 133,
      code: 'Latin',
      primary: false,
    },
    {
      id: 134,
      code: 'Latin Ballad',
      primary: false,
    },
    {
      id: 135,
      code: 'Latin Dance',
      primary: false,
    },
    {
      id: 136,
      code: 'Latin Hip Hop',
      primary: false,
    },
    {
      id: 137,
      code: 'Latin Jazz',
      primary: false,
    },
    {
      id: 138,
      code: 'Latin Pop',
      primary: false,
    },
    {
      id: 139,
      code: 'Latin Rock',
      primary: false,
    },
    {
      id: 140,
      code: 'Mambo',
      primary: false,
    },
    {
      id: 141,
      code: 'Mariachi',
      primary: false,
    },
    {
      id: 142,
      code: 'Merengue',
      primary: false,
    },
    {
      id: 143,
      code: 'MPB',
      primary: false,
    },
    {
      id: 144,
      code: 'Norteño',
      primary: false,
    },
    {
      id: 145,
      code: 'Nueva Trova',
      primary: false,
    },
    {
      id: 146,
      code: 'Pagode',
      primary: false,
    },
    {
      id: 147,
      code: 'Ranchera',
      primary: false,
    },
    {
      id: 148,
      code: 'Rasguedo',
      primary: false,
    },
    {
      id: 149,
      code: 'Reggaeton',
      primary: false,
    },
    {
      id: 150,
      code: 'Regional Mexican',
      primary: false,
    },
    {
      id: 151,
      code: 'Rumba',
      primary: false,
    },
    {
      id: 152,
      code: 'Salsa',
      primary: false,
    },
    {
      id: 153,
      code: 'Samba',
      primary: false,
    },
    {
      id: 154,
      code: 'Sertanejo',
      primary: false,
    },
    {
      id: 155,
      code: 'Sevillana',
      primary: false,
    },
    {
      id: 156,
      code: 'Son',
      primary: false,
    },
    {
      id: 157,
      code: 'Spanish',
      primary: false,
    },
    {
      id: 158,
      code: 'Spanish Folk',
      primary: false,
    },
    {
      id: 159,
      code: 'Spanish Traditional',
      primary: false,
    },
    {
      id: 160,
      code: 'Tango',
      primary: false,
    },
    {
      id: 161,
      code: 'Tejano',
      primary: false,
    },
    {
      id: 162,
      code: 'Tex',
      primary: false,
    },
    {
      id: 163,
      code: 'Tropical',
      primary: false,
    },
    {
      id: 164,
      code: 'Tropicalia',
      primary: false,
    },
    {
      id: 165,
      code: 'Trova',
      primary: false,
    },
    {
      id: 166,
      code: 'Urbano',
      primary: false,
    },
    {
      id: 167,
      code: 'Vallenato',
      primary: false,
    },
  ],
  COUNTRY: [
    {
      id: 33,
      code: 'Alt-Country',
      primary: false,
    },
    {
      id: 34,
      code: 'Bluegrass',
      primary: false,
    },
    {
      id: 35,
      code: 'Country',
      primary: false,
    },
    {
      id: 36,
      code: 'Honky Tonk',
      primary: false,
    },
    {
      id: 37,
      code: 'Pop Country',
      primary: false,
    },
    {
      id: 38,
      code: 'Traditional',
      primary: false,
    },
    {
      id: 39,
      code: 'Western',
      primary: false,
    },
    {
      id: 40,
      code: 'Western Swing',
      primary: false,
    },
  ],
};

export const selectedGenres: any = [
  {
    id: 73,
    code: 'Alternative Folk',
    primary: false,
  },
  {
    id: 74,
    code: 'Americana',
    primary: false,
  },
  {
    id: 1,
    code: 'African Blues',
    primary: false,
  },
  {
    id: 2,
    code: 'Blues',
    primary: false,
  },
  {
    id: 3,
    code: 'Boogie-Woogie',
    primary: false,
  },
  {
    id: 4,
    code: 'British Blues',
    primary: false,
  },
  {
    id: 5,
    code: 'Chicago',
    primary: false,
  },
  {
    id: 9,
    code: 'Louisiana',
    primary: false,
  },
  {
    id: 10,
    code: 'Memphis Blues',
    primary: false,
  },
  {
    id: 11,
    code: 'Piano Blues',
    primary: false,
  },
  {
    id: 104,
    code: 'Afro Latin',
    primary: false,
  },
];

export const songsList: any = [
  {
    id: 7427805,
    type: 'RECORDING',
    title: 'adele test Serob',
    songCode: 'WW 010605453 00',
    artists: ['Adele'],
    writers: ['Perception Limits Of'],
    releaseYear: 2020,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 233928,
    compatibleWithPsr: true,
    compatibleWithMsr: false,
    bpm: 0,
    expired: false,
    label: 'adele',
    hasLyrics: false,
    albumTitle: 'adele album',
    genres: ['Brazilian', 'Ballet'],
    subgenres: [],
    versions: ['Album Version'],
    wmgMaster: false,
    workAttached: true,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    languageOfPerformances: [],
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: true,
  },
  {
    id: 7427804,
    type: 'RECORDING',
    title: 'adele test Serob',
    songCode: 'WW 010605453 00',
    artists: ['Adele'],
    writers: ['Perception Limits Of'],
    releaseYear: 2020,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 233928,
    compatibleWithPsr: true,
    compatibleWithMsr: false,
    bpm: 0,
    expired: false,
    label: 'adele',
    hasLyrics: false,
    albumTitle: 'adele album',
    genres: ['Baroque'],
    subgenres: [],
    versions: ['Album Version'],
    wmgMaster: false,
    workAttached: true,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    languageOfPerformances: [],
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
  },
  {
    id: 4776944,
    type: 'RECORDING',
    title: 'ADELE',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'ADELE, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
  },
  {
    id: 4776945,
    type: 'RECORDING',
    title: 'MICHAEL JACKSON',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'MICHAEL JACKSON, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
  },
];

export const unselectedSongs: any = [
  {
    id: 4776944,
    type: 'RECORDING',
    title: 'ADELE',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'ADELE, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: false,
  },
  {
    id: 4776945,
    type: 'RECORDING',
    title: 'MICHAEL JACKSON',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'MICHAEL JACKSON, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: false,
  },
];
export const selectedSongs: any = [
  {
    id: 4776944,
    type: 'RECORDING',
    title: 'ADELE',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'ADELE, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: true,
  },
];
export const songListAllSelected: any = [
  {
    id: 7427805,
    type: 'RECORDING',
    title: 'adele test Serob',
    songCode: 'WW 010605453 00',
    artists: ['Adele'],
    writers: ['Perception Limits Of'],
    releaseYear: 2020,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 233928,
    compatibleWithPsr: true,
    compatibleWithMsr: false,
    bpm: 0,
    expired: false,
    label: 'adele',
    hasLyrics: false,
    albumTitle: 'adele album',
    genres: ['Brazilian', 'Ballet'],
    subgenres: [],
    versions: ['Album Version'],
    wmgMaster: false,
    workAttached: true,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    languageOfPerformances: [],
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: true,
  },
  {
    id: 7427804,
    type: 'RECORDING',
    title: 'adele test Serob',
    songCode: 'WW 010605453 00',
    artists: ['Adele'],
    writers: ['Perception Limits Of'],
    releaseYear: 2020,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 233928,
    compatibleWithPsr: true,
    compatibleWithMsr: false,
    bpm: 0,
    expired: false,
    label: 'adele',
    hasLyrics: false,
    albumTitle: 'adele album',
    genres: ['Baroque'],
    subgenres: [],
    versions: ['Album Version'],
    wmgMaster: false,
    workAttached: true,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    languageOfPerformances: [],
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: true,
  },
  {
    id: 4776944,
    type: 'RECORDING',
    title: 'ADELE',
    artists: ['MICHELE BRAGA'],
    writers: [],
    releaseYear: 2018,
    copyrightYear: 0,
    hasTrackLink: true,
    duration: 0,
    compatibleWithPsr: false,
    compatibleWithMsr: true,
    bpm: 0,
    expired: false,
    label: 'WEA ITALY',
    hasLyrics: false,
    albumTitle: 'ADELE, IN VIAGGIO CON ADELE (COLONNA SONORA ORIGINALE)',
    isrc: 'ITB401800024',
    genres: ['Soundtrack'],
    subgenres: [],
    versions: ['Instrumental'],
    wmgMaster: true,
    workAttached: false,
    themes: [],
    hasHiResolution: false,
    privateRecording: false,
    wbsElement: '',
    featuredArtists: [],
    plineYear: 0,
    languageOfPerformances: [],
    clineYear: 0,
    rocOverride: 'CA',
    rocOverrideTerritory: 'Canada',
    remarks: [],
    repertoireCompanies: [],
    products: [],
    contributors: [],
    tags: [],
    hasAudioFile: true,
    bulKUploaded: false,
    hasWorkNotes: false,
    selected: true,
  },
];
